// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"499184d9","453":"2532285e"}[chunkId] + ".chunk.js";
};